import { ref, onMounted, onUnmounted } from 'vue'

// Estado reativo de uma media query (ex: '(min-width: 1024px)'), atualizado
// quando a tela muda de tamanho. Usado quando um componente precisa existir
// em um lugar só por vez conforme o tamanho da tela — com CSS (hidden/lg:flex)
// as duas instâncias ficariam montadas ao mesmo tempo.
export function useMediaQuery(query) {
  const mql = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query) : null
  const matches = ref(mql ? mql.matches : false)
  const onChange = (e) => { matches.value = e.matches }

  onMounted(() => mql?.addEventListener('change', onChange))
  onUnmounted(() => mql?.removeEventListener('change', onChange))

  return matches
}
